<template>
    <div class="fotter_box" v-if="!isPhone">
        <template v-if="webConfig">
            <div class="d-flex  ai-center jc-between px-200">
                <div class="lef">
                    <img :src="webConfig.companyLogo[0]" class="w-250" alt="">
                    <div class="mt-20">
                        <div class="d-flex ai-center my-10">
                            <img src="../assets/footer/icondizhi.png" class="w-28 mr-10" alt="">
                            <span class="fs-14 color-fff">{{webConfig.companyaddr}}</span>
                        </div>
                        <div class="d-flex ai-center my-10">
                            <img src="../assets/footer/icondianhua.png" class="w-28 mr-10" alt="">
                            <span class="fs-14 color-fff">{{webConfig.telphone}}</span>
                        </div>
                        <div class="d-flex ai-center my-10">
                            <img src="../assets/footer/iconemail.png" class="w-28 mr-10" alt="">
                            <span class="fs-14 color-fff">{{webConfig.email}}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <img :src="webConfig.companyQr[0]" class="w-120" alt="">
                </div>
            </div>
            <div class="footer_box" v-if="webDate">
                <div class="to_text">{{ webDate.copyright }}</div>
                <div class="btom_a">
                    <a href="https://beian.miit.gov.cn/">{{ webDate.recordNumber }} </a>
                </div>
                <div class="btom_a filings_box">
                    <img src="../assets/filings.png" class="filings" alt="">
                    <a href="https://beian.mps.gov.cn/#/query/websearch?code=32118102000737" rel="noreferrer" target="_blank">苏公网安备32118102000737</a>
                </div>
            </div>

        </template>
    </div>

    <div class="phone_footer" v-else>
        <!-- <template v-if="webDate">
            <div class="d-flex ai-center jc-center icom_list">
                <div class="d-flex flex-column jc-center ai-center icon_item" v-for="(item, index) in webDate.bottomIcon" :key="index">
                   
                    <img :src="item.img[0]" class="bgc-fff icom_img" alt="">
                    <div class=" color-fff icom_title">{{ item.title }}</div>
                    <div class=" icom_subtitle" style="color:#8B8B8B">{{ item.subtitle }}</div>
                </div>
            </div>
            <div class="footer_box">
                <div class="to_text">{{ webDate.copyright }}</div>
                <div class="btom_a">
                    <a style="color: #8B8B8B;" href="https://beian.miit.gov.cn/">{{ webDate.recordNumber }} </a>
                </div>
            </div>
        </template> -->
        <template v-if="webConfig">
            <div class="d-flex ai-center jc-between  phone_left">
                <div class="lef">
                    <img :src="webConfig.companyLogo[0]" class="logo" alt="">
                    <div class="info_box">
                        <div class="d-flex ai-center imgspan ">
                            <img src="../assets/footer/icondizhi.png" class="icon_img" alt="">
                            <span class="span_txt color-fff">{{webConfig.companyaddr}}</span>
                        </div>
                        <div class="d-flex ai-center imgspan">
                            <img src="../assets/footer/icondianhua.png" class="icon_img" alt="">
                            <span class="span_txt color-fff">{{webConfig.telphone}}</span>
                        </div>
                        <div class="d-flex ai-center imgspan">
                            <img src="../assets/footer/iconemail.png" class="icon_img" alt="">
                            <span class="span_txt color-fff">{{webConfig.email}}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <img :src="webConfig.companyQr[0]" class="qr_img" alt="">
                </div>
            </div>
            <div class="footer_box" v-if="webDate">
                <div class="to_text">{{ webDate.copyright }}</div>
                <div class="btom_a">
                    <a href="https://beian.miit.gov.cn/">{{ webDate.recordNumber }} </a>
                </div>
                <div class="btom_a filings_box">
                    <img src="../assets/filings.png" class="filings" alt="">
                    <a href="https://beian.mps.gov.cn/#/query/websearch?code=32118102000737" rel="noreferrer" target="_blank">苏公网安备32118102000737</a>
                </div>
            </div>

        </template>

    </div>

</template>

<script setup>
import { ref, computed } from 'vue'
import footer1 from '../assets/footer/footer1.png'
import footer2 from '../assets/footer/footer2.png'
import footer3 from '../assets/footer/footer3.png'
import footer4 from '../assets/footer/footer4.png'
import footer5 from '../assets/footer/footer5.png'
import { useStore } from 'vuex'
const store = useStore()
const webDate = computed(() => store.state.webDate);
const webConfig = computed(() => store.state.webConfig);

const isPhone = ref(false);
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
if (flag) {
    isPhone.value = true;
}
</script>
<style scoped lang='scss'>
.fotter_box {
    background: #362e2e;
    width: 100%;
    height: 385px;
    min-width: 1920px;
}

.footer_box {
    width: 100%;
    min-width: 1920px;
    height: 55px;
    // background-color: #080808;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    margin-top: 30px;
    .to_text {
        font-size: 12px;
        padding-bottom: 6px;
    }

    .btom_a {
        font-size: 12px;
        color: #ffffff;
        display: flex;
        align-items: center;
        .filings {
            width: 12px;
            height: 13px;
            margin-right: 4px;
        }
        a:hover {
            text-decoration: underline;
        }
    }
    .filings_box {
        margin-top: 6px;
    }
}

.visitel {
    visibility: hidden;
}

.phone_footer {
    background: #362e2e;
    width: 100%;
    height: 21.06rem;
    min-width: 100vw;
    .phone_left {
        padding: 0 2.25rem;
        .lef {
            .logo {
                width: 15.63rem;
            }
            .info_box {
                margin-top: 1.25rem;
                .imgspan {
                    margin: 0.63rem 0;

                    .icon_img {
                        width: 1.75rem;
                        margin-right: 0.63rem;
                    }
                    .span_txt {
                        font-size: 0.88rem;
                    }
                }
            }
        }
        .right {
            .qr_img {
                width: 7.5rem;
            }
        }
    }

    .footer_box {
        width: 100%;
        min-width: 100vw;
        height: 3.44rem;
        // background-color: #080808;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        margin-top: 0.88rem;
        .to_text {
            font-size: 0.75rem;
            padding-bottom: 0.38rem;
        }

        .btom_a {
            font-size: 0.75rem;
            color: #ffffff;
            display: flex;
            align-items: center;
            .filings {
                width: 8px;
                height: 9px;
                margin-right: 2px;
            }
            a:hover {
                text-decoration: underline;
            }
        }
        .filings_box {
            margin-top: 3px;
        }
    }
}
</style>